import { Button } from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import React from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  setEventCreatedSuccessModal: () => void;
};
const TopUpSuccessModal = ({ isOpen, onClose, setEventCreatedSuccessModal }: Props) => {
  return (
    <LocalModal
      isOpen={isOpen}
      footer={
        <div className='w-full flex justify-end'>
          <Button
            variant='block'
            color='primary'
            className='mt-4 h-[41px] w-[158px]'
            onClick={() => {
              onClose();
              setEventCreatedSuccessModal();
            }}>
            Done
          </Button>
        </div>
      }
      onRequestClose={onClose}
      title=''>
      <div className='w-full'>
        <p className='text-[#2E3031] text-[18px] font-medium'>
          You’ve successfully topped up South Socials wallet with NGN 500,000
        </p>
      </div>
    </LocalModal>
  );
};

export default TopUpSuccessModal;
